// /src/components/common/PdfDetails.js
import React, {
  useEffect,
  useContext,
  useState,
  useRef,
  forwardRef,
} from "react";
import Cookies from "js-cookie";
import PatientContext from "../../../context/PatientContext";
import "./index.css";
import ReactToPrint from "react-to-print";
import { useNavigate } from "react-router-dom";
import ProtocolTable from "./ProtocolTable";
import Disclaimer from "./Disclaimer";

const PrintPdfDetails = forwardRef((props, ref) => {
  const [patientInfo, setPatientInfo] = useState(props.PdfInfo);
  const { patientDetails } = useContext(PatientContext);
  const { contextPatientReport } = useContext(PatientContext);
  const [apidata, setAPI] = useState();
  const [units, setUnits] = useState(props.units);
  useEffect(() => {
    setPatientInfo(props.PdfInfo);
    setUnits(props.units);
    // const report = contextPatientReport.data.data;
    setAPI(contextPatientReport.data);
  }, [props.PdfInfo, contextPatientReport, patientDetails, props.units]);

  const loginDetails = JSON.parse(Cookies.get("login_details"));

  const renderFooter = (pageNumber, totalPage) => (
    <footer className="pdf-footer-container">
      <div className="pdf-footer-row">
        <div className="pdf-footer-left">
          <p className="footer-text mb-4">
            Accessed &amp; utilized by{" "}
            <span className="text-capital">{loginDetails.executive}</span>
          </p>
        </div>
        <p className="footer-text pdf-footer-page">
          Page {pageNumber} of {totalPage}
        </p>
      </div>
      <div className="style-line-container">
        <div className="line-1"></div>
        <div className="line-2"></div>
      </div>
    </footer>
  );

  const renderHeader = () => (
    <div className="page-header">
      <h1 className="header-heading">Participant Report</h1>
      <img
        className="header-log"
        src="/apollo-white-logo.png"
        alt="apollo-logo"
      />
    </div>
  );

  // Each entry is the content of one page. Page numbers are derived from this list.
  const pages = [];

  // Page 1: participant info, physical attributes, medical & family history
  pages.push(
        <div className="pdf-content-container">
          <ul className="pdf-user-info-container">
            {Object.entries(patientInfo?.basic_info).map(([key, value]) => (
              <li key={key}>
                <p className="pdf-user-info-heading">{key}</p>:
                <p className="pdf-user-info-value">{value || "NA"}</p>
              </li>
            ))}
          </ul>
          <p className="line"></p>
          <h1 className="pdf-sub-heading">
            APOLLO HOSPITALS THANK YOU FOR YOUR CONSENT
          </h1>
          <p className="pdf-page-text">
            Based on current parameters, personal &#38; family history, AI
            enabled tools derive health risk scores to alert participant on
            his/her likely predisposition to a disease to aid early detection
            &#38; early medical intervention to mitigate the risk.
          </p>
          <div className="details-container">
            <h2 className="details-header">PHYSICAL ATTRIBUTES</h2>
            <ul className="details-grid">
              {Object.entries(patientInfo["Physical Attributes"]).map(
                ([key, value]) => (
                  <li key={key} className="details-item">
                    <p className="details-key">
                      {key} {units[key] && `(${units[key]})`}
                    </p>
                    <p className="details-value">{value || "NA"}</p>
                  </li>
                )
              )}
            </ul>
          </div>
          <div className="details-container heart-health-container">
            <h2 className="details-header heart-health-header">
              MEDICAL HISTORY
            </h2>
            <ul className="details-grid">
              {Object.entries(patientInfo["Medical History"]).map(
                ([key, value]) => {
                  if (value === undefined || value === null || value === "") {
                    return null
                  }
                  return (
                    <li key={key} className="details-item">
                      <p className="details-key">{key}</p>
                      <p className="details-value heart-health-value">{value ||"NA"}</p>
                    </li>
                  )
                }
              )}
            </ul>
          </div>
          <div className="details-container medical-container">
            <h2 className="details-header medical-header">FAMILY HISTORY</h2>
            <ul className="details-grid">
              {Object.entries(patientInfo["Family History"]).map(
                ([key, value]) => {
                  if (value === undefined || value === null || value === "") {
                    return null
                  }
                  return (
                    <li key={key} className="details-item">
                      <p className="details-key">{key}</p>
                      <p className="details-value medical-value">{value || "NA"}</p>
                    </li>
                  )
                }
              )}
            </ul>
          </div>
        </div>,
  );

  // Page 2: lab history + AI calculated risk score
  pages.push(
        <div className="pdf-content-container">
          <div
            className="details-container heart-health-container "
            style={{ marginTop: "10px" }}
          >
            <h2 className="details-header heart-health-header">LAB HISTORY</h2>
            <ul className="details-grid">
              {Object.entries(patientInfo["Lab History"]).map(
                ([key, value]) => {
                  if (value === undefined || value === null || value === "" || value === 0 || value === "0") {
                    return null
                  }
                  return (
                    <li key={key} className="details-item">
                      <p className="details-key">
                        {key} {units[key] && `(${units[key]})`}
                      </p>
                      <p className="details-value heart-health-value">{value || "NA"}</p>
                    </li>
                  )
                }
              )}
            </ul>
          </div>
          <div className="pdf-new-report-card pdf-report-margin-top">
            <h2 className="pdf-report-card-title">
              AI Calculated Risk Score Based on Your Inputs
            </h2>
            {apidata && (
              <div className="pdf-risk-section">
                <div className="pdf-risk-cards">
                  <div className="pdf-risk-card">
                    <h3 className="pdf-risk-card-title">Current AICKD Stage</h3>
                    <div className={`pdf-risk-value`}>
                      {apidata.current_ckd_stage}
                    </div>
                  </div>
                  <div className="pdf-risk-card">
                    <h3 className="pdf-risk-card-title">Predicted Risk Score</h3>
                    <div className={`pdf-risk-value`}>
                      {typeof apidata?.classification_model?.confidence === "number"
                        ? apidata.classification_model.confidence.toFixed(3)
                        : apidata?.classification_model?.confidence || apidata?.confidence || "-"}
                    </div>
                  </div>
                  <div className="pdf-risk-card">
                    <h3 className="pdf-risk-card-title">
                      Predicted Category of Progression
                    </h3>
                    <p
                      className={`pdf-risk-highlight ${
                        apidata["predicted_category_of_progression"] ===
                        "Severe Progression"
                          ? "red-bg"
                          : apidata["predicted_category_of_progression"] ===
                            "Mild Progression"
                          ? "green-bg"
                          : "yellow-bg"
                      }`}
                    >
                      {apidata["predicted_category_of_progression"]}
                    </p>
                  </div>
                  <div className="pdf-risk-card">
                    <h3 className="pdf-risk-card-title">
                      Predicted rate of Deterioration
                    </h3>
                    <div className={`pdf-risk-value`}>
                      {typeof apidata["predicted_rate_of_det"] === "number"
                        ? apidata["predicted_rate_of_det"].toFixed(3)
                        : apidata["predicted_rate_of_det"]}{" "}
                      mL/min/1.73 m² / year
                    </div>
                  </div>
                </div>
                <p className="note-items" style={{ marginBottom: "6px" }}>
                  <span>
                    Predicted Rate of Deterioration Range (Sigma):{" "}
                    <strong>
                      {Array.isArray(apidata["predicted_rate_of_det_range_sigma"])
                        ? `${apidata["predicted_rate_of_det_range_sigma"][0].toFixed(3)} - ${apidata["predicted_rate_of_det_range_sigma"][1].toFixed(3)}`
                        : apidata["predicted_rate_of_det_range_sigma"]}{" "}
                      mL/min/1.73 m² / year
                    </strong>
                  </span>
                </p>
                <p className="note-items" style={{ marginBottom: "6px" }}>
                  <span className="">
                    Based on the current ckd stage and predicted progression
                    category, we estimate that your likelihood to Deterioration
                    to Stage 5 is{" "}
                    <span
                      className={`${
                        apidata.risk_level === "High"
                          ? "red-color"
                          : apidata.risk_level === "Low"
                          ? "green-color"
                          : "yellow-color"
                      }`}
                    >
                      {apidata.risk_level}
                    </span>
                  </span>
                </p>
                {(() => {
                  const predictedStage =
                    apidata?.classification_model?.predicted_stage ||
                    apidata?.predicted_stage;
                  const isUncertain =
                    !predictedStage ||
                    predictedStage.toString().toLowerCase().includes("uncertain");
                  if (isUncertain) return null;
                  return (
                    <p className="note-items">
                      <span>
                        Based on your {apidata.current_ckd_stage} and profile, we
                        estimate your condition could progress to{" "}
                        <strong>{predictedStage}</strong> within the next year.
                      </span>
                    </p>
                  );
                })()}
              </div>
            )}
          </div>
        </div>,
  );

  // Page 3: AI recommended protocol
  pages.push(
    <div className="pdf-content-container">
      <div className="pdf-new-report-card pdf-report-margin-top">
        <h2 className="report-card-title">AI Recommended Protocol</h2>
        {apidata && <ProtocolTable data={apidata.CDSS} />}
      </div>
    </div>,
  );

  // Page 4: disclaimer
  pages.push(
    <div className="pdf-content-container">
      <div className="pdf-new-report-card pdf-report-margin-top">
        <h2 className="report-card-title">Disclaimer</h2>
        <Disclaimer />
      </div>
    </div>,
  );

  return (
    <div className="pdf-container" ref={ref}>
      {pages.map((content, index) => (
        <div className="page" key={index}>
          {renderHeader()}
          {content}
          {renderFooter(index + 1, pages.length)}
        </div>
      ))}
    </div>
  );
});

const CkdPdfDetails = (props) => {
  const componentRef = useRef();
  const navigate = useNavigate();

  const gotohome = () => {
    navigate("/");
  };

  return (
    <div className="pdf-report-button">
      <PrintPdfDetails
        ref={componentRef}
        PdfInfo={props.PdfInfo}
        units={props.units}
      />
      <div className="report-buttons-container">
        <button className="download-btn home-button" onClick={gotohome}>
          <img className="home-icon" src="/home-icon.svg" alt="download.svg" />
        </button>
        <ReactToPrint
          trigger={() => (
            <button className="download-btn download-button">
              <img
                className="download-icon"
                src="/cloud-download-outline.svg"
                alt="download.svg"
              />
            </button>
          )}
          content={() => componentRef.current}
        />
      </div>
    </div>
  );
};

export default CkdPdfDetails;
